import React from "react";
import BookingSummary from "../../components/Transportation/BookingSummary/BookingSummary";

const BookingSummaryContainer: React.FC = () => {
  return <BookingSummary />;
};

export default BookingSummaryContainer;
